/**
 * Helpers for address coordinates (Google Geocoding is billed per request,
 * so coordinates are saved on the address and reused wherever possible).
 */

const trimmed = (p) => (p == null ? "" : String(p).trim());

/** Identifies an address by the fields a customer can edit. */
export function addressKey(a) {
  if (!a) return "";
  return [a.address, a.address2, a.postcode].map(trimmed).join("|");
}

/** Geocoding query: address, line 2, postcode and city, empty parts dropped. */
export function buildGeocodeQuery(a) {
  if (!a) return "";
  return [a.address, a.address2, a.postcode, a.city]
    .map(trimmed)
    .filter((p) => p && p !== "undefined" && p !== "null")
    .join(", ");
}

/** Reads a GeoJSON pinpoint ({ coordinates: [lng, lat] }) saved in Cloud. */
export function pinpointLatLng(pinpoint) {
  const c = pinpoint && pinpoint.coordinates;
  if (!Array.isArray(c) || c.length < 2) return null;
  const lng = parseFloat(c[0]);
  const lat = parseFloat(c[1]);
  if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) {
    return null;
  }
  return { lat, lng };
}

/**
 * Builds the address to save from the address form.
 * Coordinates of the old address are dropped when the address changes, and
 * the map pin is only kept when it was placed for this exact address.
 */
export function buildSavedAddress(original, edited, pin) {
  const user = { ...edited };
  const key = addressKey(edited);
  if (!original || addressKey(original) !== key) {
    delete user.lat;
    delete user.lng;
    delete user.city;
    delete user.state;
  }
  if (pin && pin.key === key && pin.lat != null && pin.lng != null) {
    user.lat = pin.lat;
    user.lng = pin.lng;
    if (pin.city) user.city = pin.city;
    if (pin.state) user.state = pin.state;
  }
  return user;
}
